import script from "./SMSCampaignsMessages.vue?vue&type=script&setup=true&lang=ts"
export * from "./SMSCampaignsMessages.vue?vue&type=script&setup=true&lang=ts"

import "./SMSCampaignsMessages.vue?vue&type=style&index=0&id=a3ef4692&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3ef4692"]])

export default __exports__